export const setObjectData = (key, data, longTerm, limitTime) => {
    const dataStore = limitTime
        ? { storeExpireTime: new Date().getTime() + limitTime, data }
        : data
    if (window.localStorage && longTerm) {
        return window.localStorage.setItem(key, JSON.stringify(dataStore))
    }

    window.sessionStorage &&
        window.sessionStorage.setItem(key, JSON.stringify(dataStore))
}

export const removeStoreData = (key, longTerm) => {
    if (window.localStorage && longTerm) {
        return window.localStorage.removeItem(key)
    }

    window.sessionStorage && window.sessionStorage.removeItem(key)
}

export const getObjectData = (key, longTerm) => {
    let store =
        longTerm && window.localStorage
            ? window.localStorage
            : window.sessionStorage

    if (store) {
        const jsonData = store.getItem(key)
        if (jsonData) {
            try {
                const dataStore = JSON.parse(jsonData)

                if (!dataStore?.storeExpireTime) {
                    return dataStore
                }

                if (dataStore?.storeExpireTime >= new Date().getTime()) {
                    return false
                }

                return dataStore?.data
            } catch {
                return false
            }
        }
        return false
    }

    return false
}

export const setStringData = (key, value, longTerm) => {
    if (window.localStorage && longTerm) {
        window.localStorage.setItem(key, value);
        return;
    }

    if (window.sessionStorage) {
        window.sessionStorage.setItem(key, value)
    }
}

export const getStringData = (key, longTerm) => {
    if (window.localStorage && longTerm) {
        return window.localStorage.getItem(key);
    }

    if (window.sessionStorage) {
        return window.sessionStorage.getItem(key)
    }
    return false
}
